function onElementInserted(containerSelector, elementSelector, callback) {
    var onMutationsObserved = function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                var elements = $(mutation.addedNodes).find(elementSelector);
                for (var i = 0, len = elements.length; i < len; i++){
                    callback(elements[i]);
                }
            }
        });
    };
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(onMutationsObserved);
    observer.observe($(containerSelector)[0], { childList: true, subtree: true });
}

defer('jQuery', () => {
  $(document).ready(function () {
      var url = window.location.origin;

      //da aggiungere url cinese
      if( url.includes("int.ferplast.com/zh-cn") || Shopify.locale == "zh-CN" ){
          $(".footer__social").hide();
          $(".social-sharing").hide();
      }

      var interval = setInterval(disableAnalytics, 1000);

      function disableAnalytics() {
          if( window.gaData != null ){
              var analyticsId = Object.keys(window.gaData)[0];
              
              if( url.includes("int.ferplast.com/zh-cn") || Shopify.locale == "zh-CN" ){
                  window['ga-disable-'+ analyticsId ] = true;
              }
              clearInterval(interval);
          }
      }
  }); 
});